/**
 * Nomes das pausas que abrem cada campanha de ligação na tela do operador.
 *
 * Devem bater exatamente com os registros de `at_pauses` criados na migration
 * 2026_08_13_100004_seed_at_pauses_comercial.php — o Asterisk devolve o nome da
 * pausa em `PausedReason`.
 */
export const commercialsICampaigns = ['Comercial I'];
export const commercialsIICampaigns = ['Comercial II'];
export const commercialsIIICampaigns = ['Comercial III'];

/** Todas as pausas de campanha comercial, em qualquer nível. */
export const allCommercialCampaigns = [
    ...commercialsICampaigns,
    ...commercialsIICampaigns,
    ...commercialsIIICampaigns,
];
